var map = {
	"./amgen.png": "84af",
	"./astrazeneca.png": "de17",
	"./janssen.png": "abc6",
	"./msd.png": "f56e",
	"./pfizer.png": "c94f",
	"./pfizer2021.png": "9b30",
	"./roche.png": "280f",
	"./teva.png": "6f6d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "246e";